import { render, staticRenderFns } from "./SettingUserList.vue?vue&type=template&id=04fc6e74&"
import script from "./SettingUserList.vue?vue&type=script&lang=ts&"
export * from "./SettingUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports